// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__36yyc","title":"ClientInsurance_title__16Ujp","itemText":"ClientInsurance_itemText__1aTcY"};